module.exports = __webpack_public_path__ + "img/sku_jk.43b6d9da.gif";